import axiosInstance from './AxiosConfig';

// Demande de création nouvelle activité
export const newActivityRequestApi = async (email, naf, social_object, near_activity, content) => {
  return axiosInstance.post('/contact/new-activity', {
    email: email,
    naf: naf,
    social_object: social_object,
    near_activity: near_activity,
    content: content,
  });
};
